import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Customization, CustomizationItems, CustomizationRules } from 'src/app/avantoeats-util/models/menu/Customization';

@Component({
  selector: 'app-customization-container',
  templateUrl: './customization-container.component.html',
  styleUrls: ['./customization-container.component.scss']
})

export class CustomizationContainerComponent implements OnInit {

  @Input() selectedCustomizationId:string;
  @Input() selectedCustomization:Customization;
  @Input() selectedItemsFromEdit:{ optionId: string, quantity: number, toppingSide:"left"|"full"|"right"|null}[];

  @Output() customizationSelectionChanged = new EventEmitter<{optionId:string, quantity:number}[]>();

  initializedId:string;
  availableItemsMap:Map<string,DisplayedCustomizationItem>;
  availableItems:DisplayedCustomizationItem[];
  maxSelectableQtty:number;
  numberOfItemsSelected:number;
  showPizzaHalfToppingOptions:boolean;
  allowQttySelection:boolean;
  isDelivery:boolean = false;//Need to change this later

  selectedItems:{optionId:string, quantity:number, itemMultiplier:number, toppingSide:"left"|"full"|"right"|null}[];
  isValid:boolean;

  constructor() { }

  ngOnInit() {
    //We need this to prevent a bug
    this.initializedId = this.selectedCustomizationId;

    this.numberOfItemsSelected = 0;
    this.isValid = true;
    this.availableItems = [];

    this.maxSelectableQtty = this.selectedCustomization.rules.max;
    this.showPizzaHalfToppingOptions = this.selectedCustomization.rules.showPizzaHalfToppingOptions;
    this.allowQttySelection = this.selectedCustomization.rules.allowQttyEdit;

    this.availableItemsMap = new Map();

    this.selectedCustomization.customizationItems.forEach((item: CustomizationItems, itemId:string) => {
      //If the customization rules say that this item is selected by default, we set it's quantity to the amount defined by the rule. If not, we use 0.
      let defaultQtty = 0;

      if(this.selectedItemsFromEdit==null || this.selectedItemsFromEdit.length <= 0){
        if(this.selectedCustomization.rules!=null){
          if(this.selectedCustomization.rules.defaultSelection!=null && this.selectedCustomization.rules.defaultSelection.has(itemId)){
            defaultQtty = this.selectedCustomization.rules.defaultSelection.get(itemId);
          }
        }
        if(this.selectedCustomization.customizationItems.get(itemId) != null && this.selectedCustomization.customizationItems.get(itemId).countsAsMultiple != null){
          defaultQtty *= this.selectedCustomization.customizationItems.get(itemId).countsAsMultiple
        }
      }
      
      this.numberOfItemsSelected+=defaultQtty;
      const newItem = new DisplayedCustomizationItem(itemId, item.title, item.displayOrder, this.selectedCustomization.getPrice(itemId, this.isDelivery),defaultQtty, item.countsAsMultiple);
      this.availableItems.push(newItem)
      this.availableItemsMap.set(itemId,newItem)
    })
    this.availableItems.sort((a, b) => a.order < b.order ? -1 : a.order > b.order ? 1 : 0);

    if(this.selectedItemsFromEdit!=null && this.selectedItemsFromEdit.length > 0){
      this.selectedItemsFromEdit.forEach((item)=>{
        this.availableItemsMap.get(item.optionId).quantitySelected = item.quantity;
        this.availableItemsMap.get(item.optionId).setPizzaSide(item.toppingSide);
      })
    }

    this.updateSelectedItems();
  }

  clickCheckbox(checkboxIndex){
    if(!this.allowQttySelection){

      //If this item is already set, we change it's quantity to 0
      if(this.availableItems[checkboxIndex].quantitySelected>0){
        this.changeQuantity(0, checkboxIndex);
      }else{
        //If only one item can be selected, THIS item will have it's quantity set as 1 and all others will be de-selected
        if(this.maxSelectableQtty==1){
          this.availableItems.forEach(element => { element.quantitySelected = 0; });
          this.changeQuantity(1, checkboxIndex);
        }else{
          //If selecting this item does NOT go over the max quantity available...
          if(this.maxSelectableQtty==null || this.numberOfItemsSelected < this.maxSelectableQtty){
            this.changeQuantity(1, checkboxIndex);
          }else{
            //...if it does, nothing happens...
            //Maybe make the text flash?
          }
        }
      }

    }
  }

  getRequiredQttyMsg(rules:CustomizationRules){
    if((rules.min == null || rules.min==0) && rules.max == null){
      return "";
    }

    let msg = "SELECT ";

    if(rules.min!=null && rules.min>0){
      if(rules.max == null){
        msg += "AT LEAST ";
      }
      msg += rules.min+" ";
    }

    if(rules.max!=null){
      if(rules.min == null || rules.min == 0){
        msg += "UP TO ";
      }else if(rules.min != rules.max){
        msg += "TO A MAXIMUM OF ";
      }else{
        //max and min are the same - no need to print the max
        return msg;
      }
      msg += rules.max;
    }

    return msg;
  }

  changeQuantity(newQuantity, index){
    this.availableItems[index].quantitySelected = newQuantity;

    if(this.showPizzaHalfToppingOptions){
      if(newQuantity == 0){
        this.availableItems[index].setPizzaSide(null);
      }else{
        if(this.availableItems[index].selectedPizzaSide==null){
          this.availableItems[index].setPizzaSide("full");
        }
      }
    }

    this.updateSelectedItems();
  }

  updateSelectedItems(){
    let qtty = 0;

    this.selectedItems = [];
    this.availableItems.forEach((i)=>{
      if(i.quantitySelected>0){
        this.selectedItems.push({optionId:i.id, quantity:i.quantitySelected, itemMultiplier:i.multiplier, toppingSide:i.selectedPizzaSide})
        let halfToppingMultiplier = 1; // 1 * anything = anything. If there are no half toppings, the price wont change
        if(i.selectedPizzaSide=='left' || i.selectedPizzaSide=='right'){
          halfToppingMultiplier = 0.5;
        }
        qtty += (i.quantitySelected * i.multiplier * halfToppingMultiplier);
      }
    })
    this.numberOfItemsSelected =  qtty;
    this.isValid = this.selectedCustomization.isValidSelection(this.selectedItems);
    this.customizationSelectionChanged.emit(this.selectedItems);
  }

  isDisabled(item:DisplayedCustomizationItem){
    let disable = false;
    
    if(this.maxSelectableQtty>1){
      //If the product doesnt have a max limit, it's box won't be disabled
      //If it has, but it is 1, we treat it like a radio button, so no need to disable anything
      //But, if your max limit is above 1....
      if(item.quantitySelected==0 && this.numberOfItemsSelected>=this.maxSelectableQtty){
        //The checkbox is disabled if we reach the maximum limit but this item in particular hasnt been selected
        disable = true;
      }else if(item.multiplier!=null && item.multiplier>1 && item.quantitySelected==0 && this.numberOfItemsSelected<this.maxSelectableQtty && this.numberOfItemsSelected + item.multiplier > this.maxSelectableQtty){
        //We will also disable it if the item has a multiplier (like a double topping pizza) and selecting it would send us over the limit
        disable = true;
      }
    }
    return disable;
  }

  // isBtnDisabled(item:DisplayedCustomizationItem){
  //   let disable = false;
  //   if(this.numberOfItemsSelected>=this.maxSelectableQtty){
  //     disable = true;
  //   }else if(this.maxSelectableQtty>1 && item.multiplier!=null && item.multiplier>1 && this.numberOfItemsSelected + item.multiplier > this.maxSelectableQtty){
  //     //If adding one more goes over the limit
  //     disable = true;
  //   }
  //   return disable;
  // }

  isFullToppingDisabled(item:DisplayedCustomizationItem){
    let disable = false;
    if(this.numberOfItemsSelected>=this.maxSelectableQtty){
      disable = true;
    }else if(this.maxSelectableQtty==1 && item.multiplier!=null && this.numberOfItemsSelected>0 && this.numberOfItemsSelected + item.multiplier > this.maxSelectableQtty){
      //If adding one more goes over the limit
      disable = true;
    }
    return disable;
  }


  isHalfToppingDisabled(item:DisplayedCustomizationItem){
    let disable = false;
    if(this.numberOfItemsSelected>=this.maxSelectableQtty){
      disable = true;
    }else if(this.maxSelectableQtty>1 && this.numberOfItemsSelected + 0.5 > this.maxSelectableQtty){
      //If adding half more goes over the limit
      disable = true;
    }
    return disable;
  }

  allFreeItemsAdded(){
    if(this.selectedCustomization.rules.numberOfFreeItems == null){
      return true;
    }
    
    return this.selectedCustomization.rules.numberOfFreeItems <= this.numberOfItemsSelected;
  }


  /** Called whenever you click on one of the "pizza side" icons */
  pizzaSideSelected(index, selectedSide){
    this.availableItems[index].setPizzaSide(selectedSide);
    if(this.availableItems[index].quantitySelected == 0){
      this.changeQuantity(1,index);
    }else{
      this.updateSelectedItems();
    }
  }

}

/** Stores information about the customization items displayed by this component.
 * We use this object to make things easier
 */
export class DisplayedCustomizationItem{
  id:string;
  title:string;
  titleSuffix:string;
  order:number;
  price:number;
  multiplier:number; //<== Some items count as multiples (like double topping pizzas)
  quantitySelected:number;
  selectedPizzaSide:"left"|"full"|"right"|null

  constructor(id:string, itemTitle:string, itemOrder:number, price:number, defaultQtty:number, multiplier:number){
    this.id     = id;
    this.title  = itemTitle;
    this.order  = itemOrder;
    this.price = price;
    this.quantitySelected = (defaultQtty!=null)?defaultQtty:0;
    this.multiplier = multiplier!=null?multiplier:1;
  }

  setPizzaSide(side:"left"|"full"|"right"|null){
    this.selectedPizzaSide = side;
    if(side=="left"){
      this.titleSuffix = "(LEFT SIDE)";
    }else if(side == "right"){
      this.titleSuffix = "(RIGHT SIDE)"
    }else{
      this.titleSuffix = "";
    }
  }
}

